export const useStartLineAnnotations = (
  annotations: RevisionAnnotations,
  paragraph: Paragraph,
  token: ParagraphToken
) => {
  const startLineAnnotations = annotations.filter(
    (annotation: RevisionAnnotation) => {
      annotation.tokenGlobalPositions.sort((a, b) => a - b);

      // If hte annotation is start line and the last token is this one
      if (
        annotation.isStartLine == true &&
        annotation.paragraphId == paragraph.id
      ) {
        return annotation.lastTokenGlobalPosition == token.globalPosition;
      }

      // IEW Has decided they always want it after. I'll leave htis code in here just in case.
      return false;
      // return (
      //   annotation.forceAfterToken != true &&
      //   annotation.tokenGlobalPositions.length == 1 &&
      //   annotation.tokenGlobalPositions[0] == token.globalPosition
      // );
    }
  );

  return [...startLineAnnotations];
};
